import { css } from '@emotion/react'
import { AnimatePresence, type HTMLMotionProps, motion } from 'motion/react'
import { Fragment, type ReactNode } from 'react'

export interface EmptyPlaceholderProps extends Omit<HTMLMotionProps<'div'>, 'title' | 'children'> {
	title?: ReactNode
	children?: ReactNode
}

export default function EmptyPlaceholder({ title, children, ...props }: EmptyPlaceholderProps) {
	return (
		<motion.div
			initial={{
				opacity: 0,
			}}
			animate={{
				opacity: 1,
				transition: {
					delay: 0.5,
				},
			}}
			exit={{
				opacity: 0,
			}}
			css={css`
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 16px;
			`}
			{...props}
		>
			<AnimatePresence>
				{title &&
					(typeof title === 'string' ? (
						<motion.div
							key="empty-placeholder-title"
							css={css`
								text-align: center;
								font-weight: 400;
								font-size: 14px;
								line-height: 22px;
								color: var(--tint-secondary);
							`}
						>
							{title}
						</motion.div>
					) : (
						title
					))}

				<Fragment key="empty-placeholder-content">{children}</Fragment>
			</AnimatePresence>
		</motion.div>
	)
}
